module.exports = __webpack_public_path__ + "media/V99.158001e5.mp4";